// Get All Filter Buttons
var buttons = document.querySelectorAll('.post_filters__item button');
if(buttons){
   // Loop each button and add click event
	[].forEach.call(buttons, function(button) {
		button.addEventListener('click', () => {
      var transition = 'fade';
    	var speed = 250;
    	var data  = button.dataset;

    	// Call Ajax Load More `filter` method
    	ajaxloadmore.filter(transition, speed, data);

      // Hide the original card grid
      const parent = button.closest('.post_filters');
      const original_grid = parent.nextElementSibling.querySelector('.card_grid:not(.alm-listing)');
      original_grid.classList.add('hidden');
    });
	});
}
